import { render, staticRenderFns } from "./CampaignSummarySettings.vue?vue&type=template&id=2aec8f4e&scoped=true&"
import script from "./CampaignSummarySettings.vue?vue&type=script&lang=js&"
export * from "./CampaignSummarySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec8f4e",
  null
  
)

export default component.exports